import { useEffect } from "react";

import { useDispatch, useSelector } from "common/utilities/react-redux";
import { getSiteLanguage } from "domains/language/selectors";
import { fetchTopicContentMeta } from "domains/topicSearchFilter/actions";
import {
  getContentHasFilters,
  getTopicContentMetaIsLoaded,
  getTopicFilters,
} from "domains/topicSearchFilter/selectors";
import type { FilterCategories } from "domains/topicSearchFilter/types";

export const useTopicContentMeta = (type: FilterCategories) => {
  useFetchTopicContentMeta();
  const hasFilters = useSelector(getContentHasFilters(type));
  const filters = useSelector(getTopicFilters(type));
  return { filters, hasFilters };
};

export const useFetchTopicContentMeta = () => {
  const dispatch = useDispatch();
  const siteLanguage = useSelector(getSiteLanguage);
  const isTopicContentMetaLoaded = useSelector(getTopicContentMetaIsLoaded);

  useEffect(() => {
    if (!isTopicContentMetaLoaded) dispatch(fetchTopicContentMeta());
  }, [dispatch, isTopicContentMetaLoaded, siteLanguage]);
};
